import uuidValidator from './uuidValidator';

export default uuidValidator;
